<template>
	<b-select
	size="sm"
	value-field="key"
	text-field="label"
	class="float-left"
	:options="languages" v-model="preferredLanguage">
	</b-select>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		computed:{
			...mapGetters({
				languages: "localization/languages"
			}),
			preferredLanguage:{
				set(v){
					this.$store.commit("localization/setPreferredLanguage", v);
				},
				get(){
					return this.$store.state.localization.preferredLanguage;
				}
			}
		}
	}
</script>

<style></style>